import { AcornsIcon } from '@acorns/icons'
import { Bodytext, Button, Card, Heading } from '@acorns/web-components'
import { motion } from 'framer-motion'
import styled from 'styled-components'

import { style } from 'theme'

const CUSTOM_SCREEN_SIZE = '560px'

export const Container = styled.div`
  display: flex;
  max-width: 800px;
  justify-content: center;
  align-items: center;
  margin: auto;
`

export const CenterItems = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  margin-top: 80px;
  max-width: 400px;
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-top: 25px;
  }
`
export const StyledHeading = styled(Heading)<{ fontSize: string }>`
  font-size: ${props => props.fontSize};
  text-align: center;
  line-height: 30px;
`
export const StyledDescription1 = styled(Bodytext)`
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: center;
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-left: 30px;
    margin-right: 30px;
  }
`
export const StyledDescription2 = styled(Bodytext)`
  text-align: center;
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-left: 30px;
    margin-right: 30px;
  }
`
export const StyledButton = styled(Button)<{ width: string }>`
  width: ${props => props.width};
  margin-top: 20px;
  &&& {
    background: ${style(theme => theme.colors.slate)};
  }
`
export const StyledArrowRight = styled(AcornsIcon)`
  width: 24px;
  height: 24px;
  path {
    &[fill] {
      fill: ${style(theme => theme.colors.white)};
    }
  }
`
export const StyledMarginArrowRight = styled(StyledArrowRight)`
  margin-left: 5px;
`
export const StyledArrowLeft = styled(AcornsIcon)`
  width: 24px;
  height: 24px;
  path {
    &[fill] {
      fill: ${style(theme => theme.colors.white)};
    }
  }
`
export const IconContainer = styled.button`
  background-color: ${style(theme => theme.colors.slate)};
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  border: none;
  z-index: 1;
  cursor: pointer;
`
export const ArrowsContainer = styled(motion.div)`
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  position: absolute;
  top: 35%;
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    position: fixed;
    z-index: 2;
    bottom: 0%;
    margin-bottom: 40px;
    top: auto;
  }
`
export const StyledCard = styled(Card)`
  height: 648px;
  overflow: hidden;
  position: relative;
  width: 100%;

  @media screen and (max-width: ${style(theme => theme.breakpoints.md)}px) and (min-width: ${style(
      theme => theme.breakpoints.sm,
    )}px) {
    width: calc(100% - 60px);
  }

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    border-radius: 0px;
    height: calc(100vh - 70px);
  }
`

export const CenterContainer = styled.div`
  max-width: 295px;
  border-radius: 10px;
  border: 1px solid ${style(theme => theme.colors.ivory)};
  margin-top: 12px;
  @media (min-width: ${style(
      theme => theme.breakpoints.sm + 1,
    )}px) and (max-width: ${CUSTOM_SCREEN_SIZE}) {
    max-width: 190px;
  }
`

export const CenterContainerText = styled.p`
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  font-weight: 600;
  margin: 20px;
  @media (min-width: ${style(
      theme => theme.breakpoints.sm + 1,
    )}px) and (max-width: ${CUSTOM_SCREEN_SIZE}) {
    margin: 10px;
  }
`

export const GreenOutlineLeaf = styled(AcornsIcon)`
  position: absolute;
  margin-left: 135px;
  top: 204px;
  @media (min-width: ${style(
      theme => theme.breakpoints.sm + 1,
    )}px) and (max-width: ${CUSTOM_SCREEN_SIZE}) {
    margin-left: 88px;
  }
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    top: 170px;
  }
`

export const SizedContainer = styled.div`
  height: 80px;
  margin-bottom: 30px;

  @media screen and (max-width: ${style(theme => theme.breakpoints.md)}px) {
    height: 70px;
  }

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 0px;
  }
`

export const NavContainer = styled(SizedContainer)`
  width: 100%;
`

export const Nav = styled(SizedContainer)`
  align-items: center;
  background-color: ${style(theme => theme.colors.white)};
  display: flex;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  z-index: 30;
`
export const StyledCloseXIcon = styled(AcornsIcon)`
  width: 16px;
  height: 16px;
  margin-left: 30px;
`
